import Head from "next/head";
import Layout from "../components/layout";
import RegisterForm from "../components/auth/register-form";
import { getClient, overlayDrafts } from "@/lib/sanity.server";
import { landingPagesQuery } from "@/lib/queries";

export async function getStaticProps({ preview = false }) {
  const pageContent = overlayDrafts(
    await getClient(preview).fetch(landingPagesQuery, {
      slug: "register",
    })
  )[0];
  return {
    props: {
      pageContent,
      preview,
    },
  };
}

export default function Register({ pageContent, preview }) {
  return (
    <Layout preview={preview}>
      <Head>
        <title>Register</title>
      </Head>
      <RegisterForm pageContent={pageContent} />
    </Layout>
  );
}
